import PropTypes from "prop-types"

export default function NotHeld({ isNoLongerHeld, isNotHeld }) {
  return <div className="not-held">
    {isNoLongerHeld && <div>No longer held</div>}
    {!isNoLongerHeld && isNotHeld && <div>Not held</div>}
  </div>
}

NotHeld.propTypes = {
  isNoLongerHeld: PropTypes.bool,
  isNotHeld: PropTypes.bool,
}
